import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";

export default function PostSuccessful() {
  const { urlstate, resetAllFields } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    LoadCSSforfirstTime(path);
    resetAllFields();
  }, [path]);

  const navigatepagebasedontype = () => {
    if (state?.type == "project") {
      navigate(`/${lan}/dashboard/myorders/project/recent/${state?.response?.id}`);
    } else if (state?.type == "job") {
      navigate(`/${lan}/dashboard/myorders/job/recent/${state?.response?.id}`);
    } else if (state?.type == "contest") {
      navigate(`/${lan}/dashboard/myorders/contest/active/${state?.response}`);
    } else {
      return null;
    }
  };

  // NEW: Handler for adding another project
  const handleAddAnotherProject = () => {
    navigate(`/${lan}/createpost`, {
      state: {
        response: state?.response,
        type: "1",
        theType: "1",
      },
    });
  };

  return (
    <div className="col-md-8 mx-auto signuppage">
      <div className=" mx-auto text-center">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/tick-back.svg`}
          alt=""
        />
        <h1>Congratulations! <br />Your post is now live.</h1>
      </div>
      <div className="visit mt-0">
            {state?.type === "project" && (
          <button onClick={handleAddAnotherProject} className="btn mr-2">
            Add another project
          </button>
        )}
        
        <button onClick={() => navigatepagebasedontype()} className="btn">
          View post
        </button>
        {/* NEW: Conditional render for "Add another project" */}
    
      </div>
    </div>
  );
}